module.exports = __webpack_public_path__ + "img/icon_company_weishangchang-1.3265e6d4.svg";